import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusBadgeComponent } from './status-badge.component';

@NgModule({
    declarations: [StatusBadgeComponent],
    imports: [CommonModule, MatTooltipModule],
    exports: [StatusBadgeComponent]
})
export class StatusBadgeModule {}
